import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES } from '../../../../../config/tables'

export class TablaMovimientosMercaderiaPendientesView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES} />
    )
  }
}
